import { Icon } from "@iconify/react";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addError, getCallId, getUserData } from "../../Redux/UserSlice";
import { backendApi, callPlayBot, LiveCallApi } from "../../services/service";
const CallDisconnected = ({ setPage, languageContent, userData }) => {
  const user = useSelector(getUserData);
  const call_id = useSelector(getCallId);
  const dispatch = useDispatch();

 
  return (
    <>
      <div className="heading">
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '20%'
        }}>
            <img src='./call-disconnected.png' alt='call disconnected' />
            {
                (userData.language.toLowerCase() === "en" || userData.language.toLowerCase() === "english") ? 
                <p style={{
                    color: 'black',
                    paddingTop: '3rem',
                    fontSize: '1.2rem',
                    fontWeight: 400
                }}>It seems you don't have an active call. Please call on <a href="tel:08068025680">08068025680</a> to complete your mandatory pre-issuance process.</p> :
                <p style={{
                    color: 'black',
                    paddingTop: '3rem',
                    fontSize: '1.2rem',
                    fontWeight: 400
                }}>ऐसा लगता है कि आपके पास कोई एकटिव कॉल नहीं है। अपनी अनिवार्य प्री इस्सुएन्स प्रक्रिया को पूरा करने के लिए कृपया <a href="tel:08068025680">08068025680</a> पर कॉल करें।</p>
            }
        
        </div>
        
      </div>
      
    </>
  );
};

export default CallDisconnected;
